import "./CodeFelder.css";

/**
 * Raumcode eintippen: vier grosse Felder. Darunter liegt EIN echtes
 * Eingabefeld (unsichtbar ueber den Feldern) — so kommt die normale
 * Handy-Tastatur, Einfuegen funktioniert, und die Felder zeigen nur an.
 * @category eingaben
 */
export function CodeFelder({ wert, onChange, onFertig, autoFocus = false }) {
  return (
    <div className="code-felder">
      {[0, 1, 2, 3].map((i) => (
        <span key={i} className={i < wert.length ? "voll" : i === wert.length ? "cursor" : ""} aria-hidden="true">
          {wert[i] || ""}
        </span>
      ))}
      <input
        className="code-eingabe"
        value={wert}
        onChange={(e) => onChange(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 4))}
        onKeyDown={(e) => {
          if (e.key === "Enter" && wert.length === 4) onFertig?.(wert);
        }}
        aria-label="Raumcode"
        autoCapitalize="characters"
        autoCorrect="off"
        autoComplete="off"
        spellCheck={false}
        // Kein maxLength: es schnitte "AB-CD" schon auf "AB-C" ab, bevor
        // Bindestrich und Leerzeichen herausgefiltert sind.
        autoFocus={autoFocus}
      />
    </div>
  );
}

export default CodeFelder;
